var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountingtable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.216 3.00586C8.5713 3.00586 8.8586 3.26936 8.8586 3.59406V4.78236C9.4281 4.77216 10.0673 4.77216 10.7864 4.77216H14.2136C14.9327 4.77216 15.5711 4.77216 16.1414 4.78236V3.59406C16.1414 3.26936 16.4287 3.00586 16.784 3.00586C17.1393 3.00586 17.4266 3.26936 17.4266 3.59406V4.83336C18.6591 4.92346 19.4692 5.14616 20.0641 5.69016C20.6592 6.23501 20.9014 6.97621 21 8.10586V8.95586H4V8.10586C4.0986 6.97621 4.34085 6.23586 4.93585 5.69016C5.53085 5.14616 6.34005 4.92346 7.5734 4.83336V3.59406C7.5734 3.26936 7.86155 3.00586 8.216 3.00586Z",
    fill: "#202E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.9998 13.2059V11.5059C20.9998 10.7927 20.9888 9.52111 20.9777 8.95586H4.00491C3.99386 9.52111 4.00491 10.7927 4.00491 11.5059V13.2059C4.00491 16.4112 4.00491 18.0143 4.99941 19.0097C5.99646 20.0059 7.59871 20.0059 10.8032 20.0059H14.2032C17.4077 20.0059 19.0091 20.0059 20.0053 19.0097C20.9998 18.0143 20.9998 16.4112 20.9998 13.2059Z",
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11H12C11.1716 11 10.5 11.6716 10.5 12.5C10.5 13.3284 11.1716 14 12 14H13C13.8284 14 14.5 14.6716 14.5 15.5C14.5 16.3284 13.8284 17 13 17H10.5",
    stroke: "#202E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17C13.25 16.5858 12.9142 16.25 12.5 16.25C12.0858 16.25 11.75 16.5858 11.75 17H13.25ZM11.75 18C11.75 18.4142 12.0858 18.75 12.5 18.75C12.9142 18.75 13.25 18.4142 13.25 18H11.75ZM13.25 10C13.25 9.58579 12.9142 9.25 12.5 9.25C12.0858 9.25 11.75 9.58579 11.75 10H13.25ZM11.75 11C11.75 11.4142 12.0858 11.75 12.5 11.75C12.9142 11.75 13.25 11.4142 13.25 11H11.75ZM11.75 17V18H13.25V17H11.75ZM11.75 10V11H13.25V10H11.75Z",
    fill: "#202E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingtable);
export default __webpack_public_path__ + "static/media/accountingtable.5b20f7ad3ff0e875f84414c2a107b299.svg";
export { ForwardRef as ReactComponent };